import { IApi } from '../interfaces/IApi';

/**
 * if want to call API, just do (example):
 *
 * const url = `${ApiService.Identity}/YourEndPointHere`;
 */
export const ApiService: IApi = {
  identity: 'https://api.apps.binus.ac.id/beemine',
  notification: 'https://api.apps.binus.ac.id/beemine/notification',
  dashboard: 'https://api.apps.binus.ac.id/beemine/dashboard',
  user: 'https://api.apps.binus.ac.id/beemine/users',
  article: 'https://api.apps.binus.ac.id/beemine/article',
  project: 'https://api.apps.binus.ac.id/beemine/project',
};

export const subscriptionKeyLMSBM7 = '3036affa50694b0fb6ba6552772007c2';
export const subscriptionKeyMyDashboardBinusMaya = 'c01143afab0f4501ac8c34f6586d6a94';
export const divisionID = '931B1DC5-A77B-48DD-A01A-A7F3AC3B7111';
export const gaTrackingID = ''; /** dev */
export const TestMode = false;
export const REDPER = '';
export const ENVIRONMENT = 'production';
